import { ReactiveVar } from '@apollo/client'
import { ColDef, GridApi } from 'ag-grid-community'
import { clearTableState } from 'utils/tableStateStorage'
import IconResetToDefault from 'assets/icons/context-menu/reset-to-default.svg'

export const resetToDefault = (
  gridApi: GridApi,
  closeMenuVar: ReactiveVar<unknown>,
  columnDefs: ColDef[],
  tableKey?: string
) => {
  return {
    icon: IconResetToDefault,
    content: 'Reset To Default',
    onClick: () => {
      closeMenuVar(false)

      if (gridApi) {
        gridApi.updateGridOptions({ columnDefs })
        gridApi.resetColumnState()
        gridApi.setFilterModel(null)

        // Clear persisted state from localStorage
        if (tableKey) {
          clearTableState(tableKey)
        }
      }
    },
  }
}
